import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { IndustryAsyncAction } from './industry.asyncAction';

const adapter = createEntityAdapter({
  selectId: (industry) => industry.id || industry.industry_id,
  sortComparer: (a, b) => a.name
    ? a.name.localeCompare(b.name)
    : a.industry_name.localeCompare(b.industry_name),
});

const initialState = {
  entities: {},
  ids: [],
  message: '',
  meta: {},
  status: {
    LIST: 'IDLE',
    DETAIL: 'IDLE',
  },
};

const industrySlice = createSlice({
  name: 'LI/INDUSTRY',
  initialState,
  reducers: {
    addone: adapter.addOne,
    addMany: adapter.addMany,
    setOne: adapter.setOne,
    setMany: adapter.setMany,
    setAll: adapter.setAll,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    setMessage: (state, action) => {
      const { payload } = action;
      state.message = payload.message || '';
    },
    setStatus: (state, action) => {
      const { payload } = action;
      if (payload.status) {
        payload.status.map((v) => {
          state.status[v] = payload.type;
        });
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(IndustryAsyncAction.getList.pending, (state) => {
        state.status.LIST = 'LOADING';
      })
      .addCase(IndustryAsyncAction.getList.rejected, (state, { error }) => {
        state.status.LIST = 'FAILED';
        state.message = error.message || 'Failed get industries';
      })
      .addCase(IndustryAsyncAction.getList.fulfilled, (state) => {
        state.status.LIST = 'SUCCESS';
        state.message = 'Succesfully get industries';
      });
    builder
      .addCase(IndustryAsyncAction.getDetail.pending, (state) => {
        state.status.DETAIL = 'LOADING';
      })
      .addCase(IndustryAsyncAction.getDetail.rejected, (state, { error }) => {
        state.status.DETAIL = 'FAILED';
        state.message = error.message || 'Failed get industry';
      })
      .addCase(IndustryAsyncAction.getDetail.fulfilled, (state) => {
        state.status.DETAIL = 'SUCCESS';
        state.message = 'Succesfully get industry';
      });
  }
});

export const { reducer: industryReducer, actions: industryAction } = industrySlice;
